// ui/mui/core/src/Tab.tsx
import { Tab as MUITab, TabProps } from '@mui/material';
export const Tab = (props: TabProps) => <MUITab data-testid="tab" {...props} />;
